export default "__VITE_ASSET__b46fcdb3__"